<template>
  <div class="bg-white shadow-md mt-10 p-6">
    <h1 class="text-3xl font-bold text-center mt-10">{{ __("Dashboard") }}</h1>

    <div class="my-10 flex justify-center flex-wrap">
      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_jobs">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="list" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Jobs") }}
        </div>
        <inertia-link :href="route('jobs.index')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_clients">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="users" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Clients") }}
        </div>
        <inertia-link :href="route('clients.index')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_users">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="user-roles" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Users") }}
        </div>
        <inertia-link :href="route('users.index')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_consent_forms">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="consent" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Consent forms") }}
        </div>
        <inertia-link :href="route('consentForms.index')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_dealerships">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="suitcase" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Dealerships") }}
        </div>
        <inertia-link :href="route('dealerships.index')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_car_makes">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="car" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Brands") }}
        </div>
        <inertia-link :href="route('carMakes.index')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_settings">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="settings" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Settings") }}
        </div>
        <inertia-link :href="route('settings.operations')" class="absolute h-full w-full"></inertia-link>
      </div>

      <div class="my-5 mx-10 flex flex-col items-center relative" v-if="auth.user.permissions.view_settings">
        <div class="bg-coral-400 w-24 h-24 flex items-center justify-center p-5">
          <icon name="reports" class="text-white fill-current h-full w-full"></icon>
        </div>
        <div class="text-center mt-4 text-lg font-bold">
          {{ __("Reports") }}
        </div>
        <inertia-link :href="route('reports.index')" class="absolute h-full w-full"></inertia-link>
      </div>
    </div>
  </div>
</template>

<script>
  import Layout from '@/Shared/Layout';
  import Icon from '@/Shared/Icon';

  export default {
    layout: Layout,
    props: {
      auth: Object,
    },
    metaInfo() {
      return {
        title: this.__("Dashboard")
      }
    },
    components: {
      Layout,
      Icon
    }
  }
</script>
